
import React from 'react';
import { MessageSquare, Lightbulb, Settings, Check } from 'lucide-react';

const HowItWorksSection: React.FC = () => {
  const steps = [
    {
      icon: MessageSquare,
      title: "1. Kennismakingsgesprek",
      description: "We beginnen met een vrijblijvend gesprek over jouw bedrijf en behoeften."
    },
    {
      icon: Lightbulb,
      title: "2. Advies op maat",
      description: "We stellen een plan op dat past bij jouw situatie en budget."
    },
    {
      icon: Settings,
      title: "3. Implementatie",
      description: "We helpen je met het implementeren van de gekozen AI-oplossingen."
    },
    {
      icon: Check,
      title: "4. Resultaat & ondersteuning",
      description: "We zorgen dat alles werkt en blijven beschikbaar voor vragen."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Hoe wij werken</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Een duidelijk proces waarin jij centraal staat — van eerste gesprek tot werkende oplossing.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gray-200 z-0 -ml-4"></div>
                )}
                <div className="bg-white rounded-lg p-6 relative z-10">
                  <div className="w-16 h-16 bg-noordblue-light rounded-full flex items-center justify-center mb-4 mx-auto">
                    <Icon className="h-8 w-8 text-noordblue" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800 text-center">{step.title}</h3>
                  <p className="text-gray-600 text-center">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
